import {Typography, Grid,Divider } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionKeys, Tabs } from '../../../_constants/individualFields.constant';
import DynamicQuestionWrapper from '../../../components/DynamicQuestion/DynamicQuestionWrapper';
import { grey } from '@mui/material/colors';
import { useSelector } from 'react-redux';

  const InitialBudget = ({value}) => {
  const { t } = useTranslation();
  const {allFields}= useSelector(state => state.individualField.initialFieldsList)

  
  const salesPriceFields = useMemo(
    () =>
      allFields.filter(
        (field) => field.fieldDisplayPosition === `${Tabs.FINAL_BUDGET}.${SectionKeys.SALES_PRICE}`
      ),
    [allFields]
  );

  const purchasePerUnitFields = useMemo(
    () =>
      allFields.filter(
        (field) => field.fieldDisplayPosition === `${Tabs.FINAL_BUDGET}.${SectionKeys.PURCHASE_PER_UNIT}`
      ),
    [allFields]
  );
  const salesTotalFields = useMemo(
    () =>
      allFields.filter(
        (field) => field.fieldDisplayPosition === `${Tabs.FINAL_BUDGET}.${SectionKeys.SALES_TOTAL}`
      ),
    [allFields]
  );
  
  return (
    <>
      <Typography
          variant="h6"
          sx={{
              px: 2,
              py: 1.5
          }}>
          {t('buyersGuide.options.individualOption.finalBudget')}
      </Typography>
      <Divider sx={{
          my: 0
      }} />
      <Grid container sx={{py: 1}} spacing={{ xs: 2, md: 0 }}>
        <Grid size={{ xs: 12, md: 6 }} sx={{ borderRight: { xs: "none",sm: "none", md: `1px dashed ${grey[200]}` } }}>
          <Grid container spacing={1} sx={{ px: 2,mb: 2}}>
            <Grid size={{ xs: 12}}>
              <Typography variant="body1">{t("buyersGuide.options.individualOption.salesPerUnit")}</Typography>
            </Grid>
            <Grid size={{ xs: 12}}>
              <Divider sx={{
                my: 0
              }} />
            </Grid>
          </Grid>
          <DynamicQuestionWrapper questions={salesPriceFields} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Grid container spacing={1} sx={{ px: 2,mb: 2}}>
            <Grid size={{ xs: 12}}>
              <Typography variant="body1">{t("buyersGuide.options.individualOption.purchasePerUnit")}</Typography>
            </Grid>
            <Grid size={{ xs: 12}}>
              <Divider sx={{
                my: 0
              }} />
            </Grid>
          </Grid>
          <DynamicQuestionWrapper questions={purchasePerUnitFields} />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }} >
          <Grid container spacing={1} sx={{ px: 2,mb: 2}}>
            <Grid size={{ xs: 12}}>
              <Typography variant="body1">{t("buyersGuide.options.individualOption.salesTotal")}</Typography>
            </Grid>
            <Grid size={{ xs: 12}}>
              <Divider sx={{
                my: 0
              }} />
            </Grid>
          </Grid>
          <DynamicQuestionWrapper questions={salesTotalFields} />
        </Grid>
      </Grid>
    </>
  );
};

export default InitialBudget;
